import { Text, Tooltip } from 'bold-ui'
import React from 'react'
import { formatDate } from 'util/date/formatDate'
import { humanizeAge } from 'util/date/humanize-age'
import { beforeEqual130YearsFromDate } from 'util/validation'
import { ParticipanteModel } from 'view/atividade-coletiva/model-atividadeColetiva'
import {
  getCidadaoIdadeTooltipText,
  hasDataNascimentoAfterDataAtividade,
} from 'view/atividade-coletiva/utils-atividadeColetiva'

interface ParticipanteCidadaoIdadeInfoProps {
  participante: ParticipanteModel
  dataAtividade: LocalDate | undefined
}

export function ParticipanteCidadaoIdadeInfo(props: Readonly<ParticipanteCidadaoIdadeInfoProps>) {
  const { dataAtividade, participante } = props
  const cidadao = participante.cidadao ?? participante.cidadaoParticipante

  const cidadaoHasDataNascimentoAfterDataAtividade = hasDataNascimentoAfterDataAtividade(
    dataAtividade,
    cidadao.dataNascimento
  )

  const cidadaoParticipanteHasIdadeSuperiorIdadeMaxima = !!beforeEqual130YearsFromDate(dataAtividade)(
    participante.cidadaoParticipante?.dataNascimento
  )

  const cidadaoHasDataNascimentoInvalida =
    cidadaoHasDataNascimentoAfterDataAtividade || cidadaoParticipanteHasIdadeSuperiorIdadeMaxima

  const cidadaoIdadeTooltipText = getCidadaoIdadeTooltipText(
    cidadaoHasDataNascimentoAfterDataAtividade,
    cidadaoParticipanteHasIdadeSuperiorIdadeMaxima
  )

  return (
    <Tooltip text={dataAtividade ? cidadaoIdadeTooltipText : ''} placement='bottom-start'>
      {cidadaoHasDataNascimentoInvalida ? (
        <Text color='danger'>{formatDate(cidadao.dataNascimento)}</Text>
      ) : (
        <Text>{humanizeAge(cidadao.dataNascimento, dataAtividade)}</Text>
      )}
    </Tooltip>
  )
}
